import React, { Component } from 'react'
import PropTypes from 'prop-types'

class LdapInput extends Component {
  static propTypes = {
    values: PropTypes.array,
    onChange: PropTypes.func,
    removeOption: PropTypes.func,
    translate: PropTypes.func,
    customTitle: PropTypes.func,
    isLm: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  constructor() {
    super()

    this.state = {
      cleanValue: '',
      onFocus: false,
    }
  }

  renderSelectedOptions() {
    const { values, removeOption } = this.props

    return (values && values.length ? values : []).map((value, i) => (
      <span className='input-container-select-multiple-option' key={i}>
        <span className='input-container-select-multiple-option-text'>{value}</span>
        <span className='times'
              onClick={(e) => {
                e.stopPropagation()
                removeOption(i)
              }}
              onMouseDown={(e) => {
                e.stopPropagation()
                e.preventDefault()
              }}
        >
          ×
        </span>
      </span>
    ))
  }

  get showPlaceholder() {
    const { values } = this.props

    const hasNoLdapSelected = !values || values.length === 0
    const hasNoLdapTyped = this.state.cleanValue.length === 0

    return hasNoLdapSelected && hasNoLdapTyped
  }

  render() {
    const { onChange, translate, customTitle = null, isLm = false, disabled = false } = this.props
    const { onFocus, } = this.state
    return (
      <div
        className={`input-container input-container-select flex-row ${disabled ? "ldap-input-disabled" : ""}`}
        style={{ width: '100%', maxWidth: 'unset' }}
      >
        <label style={disabled ? {color:"#b7b2b7"} : {}}> {customTitle || translate('mobile.update.create.release.ldap')} </label>
        <div
          style={disabled ? {backgroundColor:"#eeeef0"} : {}}
          className={`as-input form-control to-input ${
            (onFocus || !this.showPlaceholder) && 'border'
          }`}
        >
          {this.renderSelectedOptions()}
          <input
            disabled={this.props.disabled}
            type='text'
            placeholder={
              this.showPlaceholder &&
              (isLm ? "Digite um ou mais LMs" : translate('mobile.update.create.release.ldap.input'))
            }
            className='search-input'
            onFocus={() => this.setState({ onFocus: true })}
            onBlur={() => {
              setTimeout(() => {
                this.setState({ onFocus: false })
              }, 100)
            }}
            onChange={({ target }) => {
              const regex = new RegExp('[0-9]', 'g')
              const cleanValue = (target.value.match(regex) || []).join('')

              this.setState({ cleanValue }, () => {
                if ((cleanValue && cleanValue.length) === 8) {
                  onChange(target.value)
                  this.setState({ cleanValue: '' })
                }
              })
            }}
            onPaste={(event) => {
              event.preventDefault();
              const pastedData = event.clipboardData
                .getData("Text")
                .split(/[,\s]+/)
                .filter((item) => /^\d{8}$/.test(item.trim()));

              if (pastedData.length) {
                pastedData.forEach((value) => this.props.onChange(value));
              }
            }}
            value={this.state.cleanValue || ''}
            style={!this.showPlaceholder ? { width: 100 } : {}}
          />
        </div>
      </div>
    )
  }
}

export default LdapInput
